// extracted by mini-css-extract-plugin
module.exports = {"editableTitle":"BlockHead_editableTitle__1bk-g"};